<ngx-spinner [fullScreen]="true" type="ball-clip-rotate-multiple" size="medium">
    <p class="loading">Loading ...</p>
</ngx-spinner>


<!-- Banner -->
<section id="banner">
    <div class="inner">
        <h1>Multi-Cloud Total Cost of Ownership (TCO) Calculator</h1>
        <p style="color: white;">Estimate the cost savings you can realize by migrating your workloads to public clouds</p>
        <!--<ul class="actions">
            <li><a href="#" class="button alt">Get Started</a></li>
        </ul> One -->
    </div>
</section>
<form class="msform" method="post">
    <!-- progressbar -->
    <ul class="progressbar">
        <li class="active">Define Workloads</li>
        <li>Adjust Assumptions</li>
        <li>View Report</li>
    </ul>
</form>
<section id="title-one">
    <div class="container">
        <header class="text-center">
            <h1>Define your workloads</h1>
            <p>Enter the details of your on-premises workloads. This information will be used to understand your current
                 TCO and recommended services in public clouds.</p>
           
            <div class="mt-1 p-1 droptitle">
                <div class="row">
                    <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                        <h4 for='Time frame'>On-premises environment</h4>
                       
                        <input type="radio" name="2" id="2" class="with-gap" [(ngModel)]="Environment" value="Physical Server"> Physical Server &nbsp;&nbsp;&nbsp;
                        <input type="radio" name="1" id="1" class="with-gap" [(ngModel)]="Environment" value="Virtual Machine"> Virtual Machine
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                        <h4 for='Time frame'>Select cloud service providers for cost estimate</h4>
                        
                        <input type="checkbox" name="4" id="4" class="with-gap" (click)="selectPlatform($event, 0)" [(ngModel)]="selectedServers[0]">&nbsp; AWS  &nbsp;&nbsp;&nbsp;&nbsp;
                        <input type="checkbox" name="3" id="3" class="with-gap" (click)="selectPlatform($event, 1)" [(ngModel)]="selectedServers[1]"> &nbsp;<span >Microsoft Azure</span>&nbsp;&nbsp;&nbsp;&nbsp;
                        <input type="checkbox" name="5" id="5" class="with-gap" (click)="selectPlatform($event, 2)" [(ngModel)]="selectedServers[2]"> &nbsp;<span >GCP</span>
                    </div>
                    <!-- <div class="col-6">
                        <h4 for='Time frame'>Select cluud service providers for cost estimate</h4>
                        <br>
                        <div class="row"  style="text-align: right;">
                            <div class="col-6">
                                <select id='serviceProviderAws' [(ngModel)]="selectedServers[0]">
                                    <option value="aws">Amazon AWS</option>
                                    <option value="azure">Microsoft Azure</option>
                                </select>
                            </div>
                            <div class="col-6">
                                <select id='serviceProviderAzure' [(ngModel)]="selectedServers[1]">
                                    <option value="none">None</option>
                                    <option value="aws">Amazon AWS</option>
                                    <option value="azure">Microsoft Azure</option>
                                </select>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </header>
    </div>
</section>
<section class="container">
    <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-12 col-12">
            <header style="margin-top: 30px;">
                <h2>Server</h2>
                <p>Enter the details of your on-premises server infrastructure. After adding a workload, select the
                    workload type and enter the remaining details.</p>
            </header>
        </div>
        <div class="col-4">
            <img src="../../../assets/images/Server.png" width="27%" alt="" class="float-right c-side-img" />
        </div>
    </div>
    <div>
        <div id="serverListContainer">
            <div *ngFor="let server of servers; let i = index" [attr.id]='server.id' [class]='i == 0 ? "mt-3" : "mt-5"'>
                <div class='row'>
                    <div style='float: left; text-align: center;' id='' class="mt-4">
                        <div class='circle' (click)="onSToggleClick(i)">
                                <img src='../../../assets/images/arrow_down.svg'  width='14px' height='14px' [attr.id]="'Server'+i"/>
                            </div>
                    </div>
                    <div class='col'>
                        <div>
                            <div class='row' [attr.id]="'div'+i" *ngIf="server.show">
                                <div class='col-lg-3 col-md-4 col-sm-6 col-12'>
                                    <input class="section_input mt-4" type=text name='name' [(ngModel)]="server.name">
                                </div>
                                <div class='input-field _input-field col-lg-3 col-sm-6 col-12 s12 m12 l12' *ngIf="false">
                                    <label for='workload'>Workload</label>
                                    <select id='workload' [(ngModel)]="server.workload">
                                        <option *ngFor="let options of shareDataService.data.server.workload" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                <div [class]="Environment === 'Physical Server' ? 'input-field _input-field col-lg-2 col-md-4 col-sm-12 col-12 s12 m12 l12' : 'input-field _input-field col-lg-2 col-md-4 col-sm-12 col-12 s12 m12 l12'">
                                    <label for='operating_systems'>Operating systems</label>
                                    <select id='Operating Systems' [(ngModel)]="server.OS">
                                        <option *ngFor="let options of shareDataService.data.server.OS" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-md-2 col-sm-6 col-12 s12 m12 l12' *ngIf="false">
                                    <label for='enviroment'>Enviroment</label>
                                    <select id='Disk type' [(ngModel)]="server.Environment">
                                        <option *ngFor="let options of shareDataService.data.server.Environment" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                
                                <div class='input-field _input-field col-md-3 col-sm-3 col-12 s12 m12 l12' *ngIf="false">
                                    <label for='os_licenses'>OS Licenses</label>
                                    <select id='os_licenses' [(ngModel)]="server.license" >
                                        <option *ngFor="let options of shareDataService.data.server.license" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-lg-1 col-md-3 col-sm-6 col-12 s12 m12 l12' *ngIf="Environment === 'Physical Server'">
                                    <label for='servers'>Servers</label>
                                    <input type='number' id='servers' (blur)="numberOfServerInputDone(i)" name='servers' [attr.value]="server.serversNumber" [attr.min]='shareDataService.data.server.serversNumber.Min' [attr.max]='shareDataService.data.server.serversNumber.Max' [(ngModel)]="server.serversNumber" >
                                    <label>{{shareDataService.data.server.serversNumber.Min + '-' + shareDataService.data.server.serversNumber.Max}}</label>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-3 col-sm-6 col-12 s12 m12 l12' *ngIf="Environment !== 'Physical Server'">
                                    <label for='VMs'>VMs</label>
                                    <input type='number' id='quantity' (blur)="numberOfVMsInputDone(i)" [attr.value]="server.NumberOfVms" [attr.min]='shareDataService.data.server.NumberOfVms.Min' [attr.max]='shareDataService.data.server.NumberOfVms.Max' [(ngModel)]="server.NumberOfVms" >
                                    <label>{{shareDataService.data.server.NumberOfVms.Min + '-' + shareDataService.data.server.NumberOfVms.Max}}</label>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-3 col-sm-6 col-12 s12 m12 l12' *ngIf="Environment === 'Physical Server'">
                                    <label for='procs_per_server'>Procs per server</label>
                                    <select id='os_licenses' [(ngModel)]="server.NoOfProcs" >
                                        <option *ngFor="let options of shareDataService.data.server.NoOfProcs" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-3 col-sm-6 col-12 s12 m12 l12' *ngIf="Environment !== 'Physical Server'">
                                    <label for='Virtualization'>Virtualization</label>
                                    <select id='Virtualization' [(ngModel)]="server.Hypervisor" >
                                        <option
                                            *ngFor="let options of shareDataService.data.server.Hypervisor"
                                            [attr.key]="options.Key"
                                            [attr.value]="options.Value"
                                        >{{options.Value}}</option>
                                    </select>
                                </div>
                           
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-6 col-12 s12 m12 l12' *ngIf="Environment === 'Physical Server'">
                                    <label for='cores_per_procs'>Core(s) per proc</label>
                                    <select id='os_licenses' [(ngModel)]="server.NoOfCores" >
                                        <option *ngFor="let options of shareDataService.data.server.NoOfCores" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-lg-1 col-md-2 col-sm-6 col-12 s12 m12 l12' *ngIf="Environment !== 'Physical Server'">
                                    <label for='cores_per_procs' >Core(s)</label>
                                    <input type='number' id='cores-of-server' (blur)="numberOfServerCoreInputDone(i)" name='servers' [attr.value]="server.NoOfCores" [attr.min]='1' [attr.max]='96' [(ngModel)]="server.NoOfCores" >
                                    <label>{{'1-96'}}</label>
                                </div>
                                <div class='input-field _input-field col-lg-1 col-md-3 col-sm-5 col-10 s12 m12 l12'>
                                    <label for='ram'>Ram(GB)</label>
                                    <input type='number' id='ram' name='ram' (blur)="serverRamInputDone($event, i)" [attr.value]="server.ram" [attr.min]="1" [attr.max]="Environment === 'Physical Server' ? 256 : 512" [(ngModel)]="server.ram">
                                    <label>{{Environment === 'Physical Server' ? '1-256' : '1-512'}}</label>
                                </div>
                                <div class='input-field _input-field col-md-3 col-sm-6 col-12 s12 m12 l12' *ngIf="false">
                                    <label for='optimised_by'>Optimised by</label>
                                    <select id='optimised_by' [(ngModel)]="server.optimizedBy" >
                                        <option *ngFor="let options of shareDataService.data.server.optimizedBy" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-md-2 col-sm-6 col-12 s12 m12 l12' >
                                    <label for='utilizaion_by'>Utilization Type</label>
                                    <select id='utilizaion_by' [(ngModel)]="server.utilizationType" (change)="onChangeServerUtilization(i)">
                                        <option *ngFor="let options of shareDataService.data.server.utilizationType" [attr.key]="options.Value.split(',')[0]" [attr.value]="730/(+options.Value.split(',')[1])">{{options.Value.split(",")[0]}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-6 col-sm-5 col-10 s12 m12 l12'>
                                    <label for='utilizaion_value'>Utilization Value</label>
                                    <input type='number' id='utilizaion_value' name='utilization' (blur)="serverUtilizationInputDone(i)" [attr.value]="server.utilization" [attr.min]="1" [attr.max]="server.maxUtilization" [(ngModel)]="server.utilization">
                                    <label>{{'1-'+server.maxUtilization}}</label>
                                </div>
                                <div 
                                    class='input-field _input-field col-md-3 col-sm-6 col-12 s12 m12 l12'
                                    *ngIf="server.workload !== 'webapp' && Environment === 'virtualmachine'"
                                >
                                    <label for='gpu'>GPU</label>
                                    <select id='gpu' [(ngModel)]="server.GPU" >
                                        <option *ngFor="let options of shareDataService.data.server.GPU" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-3 s12 m12 l12' *ngIf="false" >
                                    <label for='windows_server'>Windows Server 2008/2008 R2</label>
                                    <input type='radio' id='windows_server' name='windows_server' value='yes'>
                                </div>
                                <span class="col-1">
                                    <div style='float: left; ' class='mt-4'>
                                        <span [attr.id]="i" (click)="onSDeleteClick(server.id)"><img src='../../../assets/images/delete.svg'
                                                width='24px' height='24px' /></span>
                                    </div>
                                </span>
                            </div>
                            <!-- <div [attr.id]="'div'+i" *ngIf="server.show">
                                <div class='row  mt-2'>
                                   
                                    
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ul class="actions" >
            <li><a  (click)="addServer()" area-lable="add server workload" class="button alt mt-2" id="btnAddServer">Add Server</a></li>
        </ul>
    </div>

    <hr>

    <div class="row mt-0">
        <div class="col-lg-8 col-md-8 col-sm-12 col-12">
            <header class="mt-4">
                <h2>Database</h2>
                <p>Enter the details of your on-premises database infrastructure. After adding a database, enter the
                    details of your on-premises database infrastructure in the Source section. In the Destination
                    section,</p>
            </header>
        </div>
        <div class="col-4">
            <img src="../../../assets/images/Database.png" width="25%" alt="" class="float-right c-side-img" />
        </div>
    </div>
    <div>
        <div id="databasedListContainer">
            <div *ngFor="let database of databases; let i = index" [attr.id]="database.id" [class]='i == 0 ? "mt-3" : "mt-5"'>
                <div class='row'>
                    <div style='float: left;   text-align: center;' [attr.id]="i" class="mt-4">
            
                        <div class='circle' (click)="onDatabaseToggleClick(i)" >
                            <img src='../../../assets/images/arrow_down.svg' width='14px' height='14px' [attr.id]="'Server'+i"/>
                        </div>
            
                    </div>
                    <div class='col'>
                        <div>
                            <div class='row' [attr.id]="'div'+i" *ngIf="database.show">
                                <div class='col-lg-2 col-md-4 col-sm-4 col-12'>
                                    <input  class="section_input" type=text name='name' [(ngModel)]="database.name" class="mt-4">
                                </div>
                                <div class='input-field _input-field col-lg-3 col-md-4 col-sm-4 col-12 s12 m12 l12' *ngIf="false">
                                    <label for='workload'>Workload</label>
                                    <select id='workload' [(ngModel)]="database.workload">
                                        <option *ngFor="let options of shareDataService.data.database.workload" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-lg-3 col-md-4 col-sm-4 col-12 s12 m12 l12' *ngIf="false">
                                    <label for='enviroment'>Enviroment</label>
                                    <select id='Disk type' [(ngModel)]="database.Environment">
                                        <option *ngFor="let options of shareDataService.data.database.Environment" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-4 col-12 s12 m12 l12'>
                                    <label for='operating_systems'>Operating systems</label>
                                    <select id='Operating Systems' (change)="onChangeOs(database.OS,database)" [(ngModel)]="database.OS">
                                        <option *ngFor="let options of shareDataService.data.database.OS" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                <div [class]='Environment === "Physical Server" ? "input-field _input-field col-lg-1 col-md-3 col-sm-3 col-12 s12 m12 l12" : "input-field _input-field col-lg-2 col-md-3 col-sm-3 col-12 s12 m12 l12"'>
                                    <label for='os_licenses'>DB Engine</label>
                                    <select id='os_licenses' [(ngModel)]="database.DBEngine" >
                                        <option *ngFor="let options of database.databaseEnginList" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-lg-1 col-md-3 col-sm-3 col-12 s12 m12 l12' *ngIf="Environment === 'Physical Server'">
                                    <label for='servers'>Servers</label>
                                    <input type='number' id='servers' name='servers' (blur)="numberOfDatabaseInputDone(i)" [attr.value]="database.serversNumber" [attr.min]='shareDataService.data.database.serversNumber.Min' [attr.max]='shareDataService.data.database.serversNumber.Max' [(ngModel)]="database.serversNumber" >
                                    <label>{{shareDataService.data.database.serversNumber.Min + '-' + shareDataService.data.database.serversNumber.Max}}</label>
                                </div>
                                <div class='input-field _input-field col-lg-1 col-md-3 col-sm-3 col-12 s12 m12 l12' *ngIf="Environment !== 'Physical Server'">
                                    <label for='VMs'>VMs</label>
                                    <input type='number' id='quantity' (blur)="numberOfVMsInDBInputDone(i)" [attr.value]="database.NumberOfVms" [attr.min]='shareDataService.data.database.NumberOfVms.Min' [attr.max]='shareDataService.data.database.NumberOfVms.Max' [(ngModel)]="database.NumberOfVms" >
                                    <label>{{shareDataService.data.database.NumberOfVms.Min + '-' + shareDataService.data.database.NumberOfVms.Max}}</label>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-3 col-sm-3 col-12 s12 m12 l12' *ngIf="Environment === 'Physical Server'">
                                    <label for='procs_per_server'>Procs per server</label>
                                    <select id='os_licenses' [(ngModel)]="database.NoOfProcs" >
                                        <option *ngFor="let options of shareDataService.data.database.NoOfProcs" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-3 col-sm-4 col-12 s12 m12 l12' *ngIf="Environment !== 'Physical Server'">
                                    <label for='Virtualization'>Virtualization</label>
                                    <select id='Virtualization' [(ngModel)]="database.Hypervisor" >
                                        <option
                                            *ngFor="let options of shareDataService.data.database.Hypervisor"
                                            [attr.key]="options.Key"
                                            [attr.value]="options.Value"
                                        >{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-3 col-sm-3 col-12 s12 m12 l12' *ngIf="Environment === 'Physical Server'">
                                    <label for='cores_per_procs'>Core(s) per proc</label>
                                    <select id='os_licenses' [(ngModel)]="database.NoOfCores" >
                                        <option *ngFor="let options of shareDataService.data.database.NoOfCores" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-lg-1 col-md-2 col-sm-4 col-12 s12 m12 l12' *ngIf="Environment !== 'Physical Server'">
                                    <label for='cores_per_procs' >Core(s)</label>
                                    <input type='number' id='cores-of-db-server' (blur)="numberOfServerCoreInputDone(i)" name='servers' [attr.value]="database.NoOfCores" [attr.min]='1' [attr.max]='96' [(ngModel)]="database.NoOfCores" >
                                    <label>{{'1-96'}}</label>
                                </div>
                                <div class='input-field _input-field col-lg-1 col-md-2 col-sm-2 col-10 s12 m12 l12'>
                                    <label for='ram'>Ram(GB)</label>
                                    <input type='number' id='ram' name='ram' (blur)="databaseRamInputDone($event, i)" [attr.value]="database.ram" [attr.min]='shareDataService.data.database.ram.Min' [attr.max]='shareDataService.data.database.ram.Max' [(ngModel)]="database.ram" >
                                    <label>{{Environment === 'Physical Server' ? '1-256' : '1-512'}}</label>
                                </div>
                                <div class='input-field _input-field col-lg-3 col-md-4 col-sm-4 col-12 s12 m12 l12' *ngIf="false">
                                    <label for='optimised_by'>Optimised by</label>
                                    <select id='optimised_by' [(ngModel)]="database.optimizedBy" >
                                        <option *ngFor="let options of shareDataService.data.database.optimizedBy" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                <div 
                                    class='input-field _input-field col-lg-3 col-md-4 col-sm-4 col-12 s12 m12 l12'
                                    *ngIf="database.workload !== 'webapp' && Environment === 'virtualmachine'"
                                >
                                    <label for='gpu'>GPU</label>
                                    <select id='gpu' [(ngModel)]="database.GPU" >
                                        <option *ngFor="let options of shareDataService.data.database.GPU" [attr.key]="options.Key" [attr.value]="options.Value">{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-md-2 col-sm-6 col-12 s12 m12 l12' >
                                    <label for='utilizaion_by'>Utilization Type</label>
                                    <select id='utilizaion_by' [(ngModel)]="database.utilizationType" (change)="onChangeDatabaseUtilization(i)">
                                        <option *ngFor="let options of shareDataService.data.database.utilizationType" [attr.key]="options.Value.split(',')[0]" [attr.value]="730/(+options.Value.split(',')[1])">{{options.Value.split(",")[0]}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-6 col-sm-5 col-10 s12 m12 l12'>
                                    <label for='utilizaion_value'>Utilization Value</label>
                                    <input type='number' id='utilizaion_value' name='utilization' (blur)="databaseUtilizationInputDone(i)" [attr.value]="database.utilization" [attr.min]="1" [attr.max]="database.maxUtilization" [(ngModel)]="database.utilization">
                                    <label>{{'1-'+database.maxUtilization}}</label>
                                </div>
                                <div class='input-field _input-field col-lg-3 col-md-4 col-sm-4 col-4 s12 m12 l12' *ngIf="false" >
                                    <label for='windows_server'>Windows Server 2008/2008 R2</label>
                                    <input type='radio' id='windows_server' name='windows_server' value='yes'>
                                </div>
                                <span class="col-1">
                                    <div style='float: left;' class='mt-4'>
                                        <span [attr.id]="i" (click)="onDatabaseDeleteClick(database.id)"><img src='../../../assets/images/delete.svg' width='24px'
                                                height='24px' /></span>
                                    </div>
                                </span>
                            </div>
                            
                        </div>
                        <div [attr.id]="'divDatabase'+i" *ngIf="false">
                            <div class='row'>
                                <div class='input-field _input-field col-3 s12 m12 l12'>
                                    <label for='Database'>Database</label>
                                    <select id='Database' [(ngModel)]="database.database" >
                                        <option
                                            *ngFor="let options of shareDataService.data.database.database"
                                            [attr.key]="options.Key"
                                            [attr.value]="options.Value"
                                        >{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-3 s12 m12 l12' *ngIf="database.database === '61'">
                                    <label for='License'>License</label>
                                    <select id='License' [(ngModel)]="database.systemlicense" >
                                        <option
                                            *ngFor="let options of shareDataService.data.database.systemlicense"
                                            [attr.key]="options.Key"
                                            [attr.value]="options.Value"
                                        >{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-3 s12 m12 l12'
                                    *ngIf="database.database !== '64' && database.database !== '65'"
                                >
                                    <label for='Enviroment'>Enviroment</label>
                                    <select id='Enviroment' [(ngModel)]="database.Environment" >
                                        <option
                                            *ngFor="let options of shareDataService.data.database.Environment"
                                            [attr.key]="options.Key"
                                            [attr.value]="options.Value"
                                        >{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-3 s12 m12 l12'>
                                    <label for='Operating systems'>Operating systems</label>
                                    <select id='Operating systems' [(ngModel)]="database.OS" >
                                        <option
                                            *ngFor="let options of shareDataService.data.database.OS"
                                            [attr.key]="options.Key"
                                            [attr.value]="options.Value"
                                        >{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-3 s12 m12 l12' *ngIf="database.Environment === '2'">
                                    <label for='VMs'>VMs</label>
                                    <input type='number' id='quantity' [attr.value]="database.NumberOfVms" [attr.min]='shareDataService.data.database.NumberOfVms.Min' [attr.max]='shareDataService.data.database.NumberOfVms.Max' [(ngModel)]="database.NumberOfVms" >
                                </div>
                                <div class='input-field _input-field col-3 s12 m12 l12' *ngIf="Environment !== 'Physical Server'">
                                    <label for='Virtualization'>Virtualization</label>
                                    <select id='Virtualization' [(ngModel)]="database.Hypervisor" >
                                        <option
                                            *ngFor="let options of shareDataService.data.database.Hypervisor"
                                            [attr.key]="options.Key"
                                            [attr.value]="options.Value"
                                        >{{options.Value}}</option>
                                    </select>
                                </div>
            
                            </div>
            
                            <div class='row'>
                                <div class='input-field _input-field col-3 s12 m12 l12'>
                                    <label for='Core(s)'>Core(s)</label>
                                    <input type='number' id='quantity' [attr.value]="database.coresPerProcs" [attr.min]='shareDataService.data.database.coresPerProcs.Min' [attr.max]='shareDataService.data.database.coresPerProcs.Max' [(ngModel)]="database.coresPerProcs" >
                                </div>
                                <div class='input-field _input-field col-3 s12 m12 l12'>
                                    <label for='RAM(GB)'>Core(s) Per Server</label>
                                    <input type='number' id='quantity' [attr.value]="database.procsPerServer" [attr.min]='shareDataService.data.database.procsPerServer.Min' [attr.max]='shareDataService.data.database.procsPerServer.Max' [(ngModel)]="database.procsPerServer" >
                                </div>
            
                                <div class='input-field _input-field col-3 s12 m12 l12'>
                                    <label for='Optimise by'>Optimise by</label>
                                    <select id='Optimise by' [(ngModel)]="database.optimizedBy">
                                        <option
                                            *ngFor="let options of shareDataService.data.database.optimizedBy"
                                            [attr.key]="options.Key"
                                            [attr.value]="options.Value"
                                        >{{options.Value}}</option>
                                    </select>
                                </div>
                            </div>
            
                            <div class='row  mt-3'>
                                <div class='input-field _input-field col-3 s12 m12 l12'>
                                    <label for='Service type'>Service type</label>
                                    <select id='Service type' [(ngModel)]="database.service">
                                        <option
                                            *ngFor="let options of shareDataService.data.database.service"
                                            [attr.key]="options.Key"
                                            [attr.value]="options.Value"
                                        >{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-3 s12 m12 l12'>
                                    <label for='Purchase Model'>Purchase Model</label>
                                    <select id='Purchase Model' [(ngModel)]="database.purchasemodel">
                                        <option
                                            *ngFor="let options of shareDataService.data.database.purchasemodel"
                                            [attr.key]="options.Key"
                                            [attr.value]="options.Value"
                                        >{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-3 s12 m12 l12'>
                                    <label for='Service Tier'>Service Tier</label>
                                    <select id='Service Tier' [(ngModel)]="database.servicetier">
                                        <option
                                            *ngFor="let options of shareDataService.data.database.servicetier"
                                            [attr.key]="options.Key"
                                            [attr.value]="options.Value"
                                        >{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-3 s12 m12 l12'>
                                    <label for='Instance cores'>Instance cores</label>
                                    <select id='Instance cores' [(ngModel)]="database.instancecores">
                                        <option
                                            *ngFor="let options of shareDataService.data.database.instancecores"
                                            [attr.key]="options.Key"
                                            [attr.value]="options.Value"
                                        >{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-3 s12 m12 l12'>
                                    <label for='Instance cores'>Instance cores</label>
                                    <input type='number' id='servers' name='servers' [attr.value]="database.serversNumber" [attr.min]='shareDataService.data.database.serversNumber.Min' [attr.max]='shareDataService.data.database.serversNumber.Max*database.serversNumberType' [(ngModel)]="database.serversNumber" >
                                    <select id='Capacity' [(ngModel)]="database.serversNumberType" (ngModelChange)="databaseTypeChange($event, 'serversNumber', i)">
                                        <option value='1024'>GB</option>
                                        <option value='1'>TB</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-3 s12 m12 l12'>
                                    <label for='SQL Server storage'>SQL Server storage</label>
                                    <input type='number' id='servers' name='servers' [attr.value]="database.sqlstorage" [attr.min]='shareDataService.data.database.sqlstorage.Min' [attr.max]='shareDataService.data.database.sqlstorage.Max*database.sqlstorageType' [(ngModel)]="database.sqlstorage" >
                                    <select id='Capacity' [(ngModel)]="database.sqlstorageType" (ngModelChange)="databaseTypeChange($event, 'sqlstorage', i)">
                                        <option value='1024'>GB</option>
                                        <option value='1'>TB</option>
                                    </select>
                                </div>
                            </div>
            
            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ul class="actions" >
            <li><a (click)="addDatabase()" area-lable="add database workload" class="button alt mt-3" id="btnAddDatabase">Add Database</a></li>
        </ul>
    </div>

    <hr>

    <div class="row mt-0">
        <div class="col-lg-8 col-md-8 col-sm-12 col-12">
            <header class="mt-4">
                <h2>Storage</h2>
                <p>Enter the details of your on-premises storage infrastructure. After adding a storage, select the
                    storage type and enter the remaining details.</p>
            </header>
        </div>
        <div class="col-4">
            <img src="../../../assets/images/Storage.png" width="35%" alt="" class="float-right c-side-img" />
        </div>
    </div>
    <div>
        <div id="storageListContainer">
            <div *ngFor="let storage of storages; let i = index" [attr.id]="storage.id" class='mt-3 pb-2'>
                <div class='row'>
                    <div style='float: left;  text-align: center;' [attr.id]="i" class="mt-4">
                        <div class='circle' (click)="onSTorageToggleClick(i)">
                            <img src='../../../assets/images/arrow_down.svg' width='14px' height='14px' [attr.id]="'Server'+i"/>
                        </div>
                    </div>
                    <div class='col'>
                        <div>
                            <div class='row' [attr.id]="i" *ngIf="storage.show">
                                <div class='col-lg-3 col-md-4 col-sm-4 col-12'>
                                    <input  class="section_input" type=text name='name' class="mt-4" [(ngModel)]="storage.name">
                                </div>
                                <div [class]='storage.Storage === "Object" ? "input-field _input-field col-lg-2 col-md-6 col-sm-4 col-12 s12 m12 l12" : storage.Storage === "NAS" ? "input-field _input-field col-3 col-lg-3 col-md-2 col-sm-4 col-12 s12 m12 l12" : "input-field _input-field col-3 col-lg-3 col-sm-4 col-12 s12 m12 l12"'>
                                    <label for='Storage type'>Storage type</label>
                                    <select id='Storage type' [(ngModel)]="storage.Storage" >
                                        <option
                                            *ngFor="let options of shareDataService.data.storage.Storage"
                                            [attr.key]="options.Key"
                                            [attr.value]="options.Value"
                                        >{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-lg-3 col-md-4 col-sm-4 col-12 s12 m12 l12' *ngIf="storage.Storage === 'Object'">
                                    <label for='Archive'>Accessibility %</label>
                                    <input type='number' id='servers' [attr.value]="storage.Accessibility" [attr.min]='shareDataService.data.storage.Accessibility.Min' [attr.max]='shareDataService.data.storage.Accessibility.Max' [(ngModel)]="storage.Accessibility">
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-4 col-12 s12 m12 l12' *ngIf="storage.Storage === 'SAN'">
                                    <label for='Disk type'>Disk type</label>
                                    <select id='Disk type' [(ngModel)]="storage.DiskType">
                                        <option
                                            *ngFor="let options of shareDataService.data.storage.DiskType"
                                            [attr.key]="options.Key"
                                            [attr.value]="options.Value"
                                        >{{options.Value}}</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-lg-3 col-md-4 col-sm-4 col-10 s12 m12 l12'>
                                    <label for='operating_systems'>Capacity</label>
                                    <div class="d-flex">
                                        <input type='number' id='servers' name='servers' (blur)="storageCapacitySet(i)" [attr.value]="storage.Capacity" [attr.min]='shareDataService.data.storage.Capacity.Min*storage.capacityType' [attr.max]='shareDataService.data.storage.Capacity.Max*storage.capacityType' [(ngModel)]="storage.Capacity">
                                        <select id='Capacity' [(ngModel)]="storage.capacityType" (ngModelChange)="storageTypeChange($event, 'Capacity', i)">
                                            <option value='1'>TB</option>
                                            <option value='1024'>GB</option>
                                        </select>
                                    </div>
                                    <label>{{(shareDataService.data.storage.Capacity.Min*storage.capacityType) + '-' + (shareDataService.data.storage.Capacity.Max*storage.capacityType)}}</label>
                                </div>
                                <div class='input-field _input-field col-lg-3 col-md-4 col-sm-4 col-12 s12 m12 l12' *ngIf="false">
                                    <label for='Backup'>Backup</label>
                                    <input type='number' id='servers' name='servers' [attr.value]="storage.BackUp" [attr.min]='shareDataService.data.storage.BackUp.Min*storage.backupType' [attr.max]='shareDataService.data.storage.BackUp.Max*storage.backupType' [(ngModel)]="storage.BackUp">
                                    <select id='Capacity' [(ngModel)]="storage.backupType" (ngModelChange)="storageTypeChange($event, 'BackUp', i)">
                                        <option value='1'>TB</option>
                                        <option value='1024'>GB</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-lg-3 col-md-4 col-sm-4 col-12 s12 m12 l12' *ngIf="false">
                                    <label for='Archive'>Archive</label>
                                    <input type='number' id='servers' [attr.value]="storage.Archive" [attr.min]='shareDataService.data.storage.Archive.Min*storage.serversNumberType' [attr.max]='shareDataService.data.storage.Archive.Max*storage.serversNumberType' [(ngModel)]="storage.Archive">
                                    <select id='Capacity' [(ngModel)]="storage.archiveType" (ngModelChange)="storageTypeChange($event, 'Archive', i)">
                                        <option value='1'>TB</option>
                                        <option value='1024'>GB</option>
                                    </select>
                                </div>
                                <div class='input-field _input-field col-lg-3 col-md-3 col-sm-12 col-12 s12 m12 l12' *ngIf="storage.Storage === 'SAN' && storage.DiskType === 'SSD'">
                                    <label for='Archive'>Max IOPS per TB</label>
                                    <input type='number' id='servers' [attr.value]="storage.MaxIops" [attr.min]='shareDataService.data.storage.MaxIops.Min' [attr.max]='shareDataService.data.storage.MaxIops.Max' [(ngModel)]="storage.MaxIops">
                                </div>
                                <span class="col-1">
                                    <div style='float: left;' class='mt-4'>
                                        <span [attr.id]="i" (click)="onSTorageDeleteClick(storage.id)"><img src='../../../assets/images/delete.svg'
                                                width='24px' height='24px' /></span>
                                    </div>
                                </span>
                            </div>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ul class="actions">
            <li><a (click)="addStorage()" area-lable="add storage workload" class="button alt" id="btnAddStorage">Add Storage</a></li>
        </ul>
    </div>
    <hr>
</section>
<section class="m-2">
    <div class="container" *ngIf="false">
        <header>
            <h2 align="center">Networking</h2>
            <p align="center">Enter the amount of network bandwidth you currently consume in your on-premises enviroment.</p>
        </header>
        <div class="mt-4 row justify-content-center">
            <div class='input-field _input-field col-2 s4 l4'>
                <input type='number' id='servers' name='servers' value='1' min='1' max='20000' [(ngModel)]="network">
            </div>
            <div class='input-field _input-field col-2 s4 l4' (ngModelChange)="storageTypeChangeInNetwork($event)">
                <select id='Capacity'>
                    <option value='1'>TB</option>
                    <option value='1024'>GB</option>
                </select>
            </div>
        </div>
    </div>
    <ul class="actions" style="margin-top: 0px; text-align: center">
        <li><a class="button special" (click)="next()">Next</a></li>
    </ul>
</section>
<section>
    <div class="Orange blog c-flex" style=" text-align: center;">

        <h3 style="color: #fff;">Help us improve. Is the TCO calculator helpful?</h3>
        <div class="mt-4">
            <span class="actions m-2">
                <a class="button alt white">Next</a>
            </span>
            <span class="actions m-2">
                <a class="button alt white">No</a>
            </span>
        </div>

    </div>
</section>
